module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAAAAXNSR0IArs4c6QAAAMRJREFUSInt1LsNwyAUheFzxQbMwCBpmcp4KkSZhdgAKRURNq97baw0OSWI/+sABDPGbMaYTfJGSeIAHICX1hoxxvcyoIjnsZEp0IiLkCEwiLORLsCIs5AmIIhPkQq4EB8iB+BGvIt8gQXxJqIWxytEPRA/IP/9fhRCcEQk+uO5SyntBABPICml3VrrKB+sRHIcAKi8WIGU8Qq4i5zjTeAq0op3ASnSiw8BLjKKT4EZMouzgB7CibOBM8KNixdCcN57UfgDQuOWEY5SbiMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sort-bigger.png
// module id = MYVU
// module chunks = 1